export default __webpack_public_path__ + "static/media/Resource-Icons-Cognitive-transparent.ef96db21.png";